import {parseJwt} from "./TokenUtilization";
import jwtDecode from 'jwt-decode';

const role_authority = require('../domain/roles.json')

const getLocalRefreshToken = () => {
    try {
        const userStr = localStorage.getItem("user");
        if (!userStr) return null;
        const user = JSON.parse(userStr);
        return user?.refreshToken;
    } catch (error) {
        return null;
    }
};

const getLocalAccessToken = () => {
    try {
        const userStr = localStorage.getItem("user");
        if (!userStr) return null;
        const user = JSON.parse(userStr);
        return user?.accessToken;
    } catch (error) {
        return null;
    }
};

const updateLocalAccessToken = (token) => {
    try {
        const userStr = localStorage.getItem("user");
        if (!userStr) return;
        let user = JSON.parse(userStr);
        user.accessToken = token;
        localStorage.setItem("user", JSON.stringify(user));
    } catch (error) {
        console.error("Error updating access token:", error);
    }
};

const getUser = () => {
    try {
        const userStr = localStorage.getItem("user");
        if (!userStr) return null;
        return JSON.parse(userStr);
    } catch (error) {
        return null;
    }
};

const setUser = (user) => {
    const datalar = parseJwt(user?.access_token)
    if (datalar.tenant) {
        localStorage.setItem("selectedTenant", JSON.stringify(datalar.tenant));
    }

    localStorage.setItem("user_data", JSON.stringify(datalar));
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("authority", JSON.stringify({authorities: role_authority[datalar.role]}));
};

const removeUser = () => {
    localStorage.removeItem("user");
};


const isTokenValid = () => {
    try {
        const token = getLocalAccessToken();
        if (!token) return false;

        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000; // Unix timestamp (saniye cinsinden)

        // exp field'ı Unix timestamp olarak gelir
        // Token'ın süresi dolmuşsa false döner
        return decodedToken.exp > currentTime;
    } catch (error) {
        return false; // Token decode edilemezse veya hatalıysa
    }
}

// Token'ın bitiş süresini kontrol et ve önceden uyar
const shouldRefreshToken = () => {
    try {
        const token = getLocalAccessToken();
        if (!token) return false;

        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        // Token'ın bitiş süresine 5 dakika veya daha az kaldıysa
        const fiveMinutes = 5 * 60; // 5 dakika = 300 saniye
        return decodedToken.exp - currentTime <= fiveMinutes;
    } catch {
        return false;
    }
}

// Token'ın kalan süresini hesapla
const getTokenRemainingTime = () => {
    try {
        const token = getLocalAccessToken();
        if (!token) return 0;

        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        return Math.max(decodedToken.exp - currentTime, 0);
    } catch {
        return 0;
    }
}

const TokenService = {
    getLocalRefreshToken,
    getLocalAccessToken,
    updateLocalAccessToken,
    getUser,
    setUser,
    removeUser,
    getTokenRemainingTime,
    shouldRefreshToken,
    isTokenValid
};

export default TokenService;
